// Bootstraping
export const FETCH_ME_LOADING = 'FETCH_ME_LOADING';
export const FETCH_ME_FAILURE = 'FETCH_ME_FAILURE';
export const FETCH_ME_SUCCESS = 'FETCH_ME_SUCCESS';
export const UPDATE_FEATURE_SET = 'layout/UPDATE_FEATURE_SET';

// Plastic cards
export const FETCH_MONTHLY_BUDGET_SUCCESS = 'FETCH_MONTHLY_BUDGET_SUCCESS';
export const SET_ME_COMPANY_PLASTIC_CARD = 'SET_ME_COMPANY_PLASTIC_CARD';
